import { render, staticRenderFns } from "./HotTv.vue?vue&type=template&id=dcf2343e&scoped=true&"
import script from "./HotTv.vue?vue&type=script&lang=js&"
export * from "./HotTv.vue?vue&type=script&lang=js&"
import style0 from "./HotTv.vue?vue&type=style&index=0&id=dcf2343e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf2343e",
  null
  
)

export default component.exports